<script>
  import { onMount } from 'svelte';
  import snarkdown from 'snarkdown';
  
  export let form_id = null;
  
  let raw, markdown, updated_at;
  $: if (form_id && raw) {
    markdown = snarkdown(raw);
  }
  
  function fetchForm() {
    if (!form_id) return;
    fetch(`/data/${form_id}/text.json`)
      .then(r => r.json())
      .then(data => {
        raw = data.data; //.replace(/(<([^>]+)>)/gi, "");
        updated_at = data.updated_at;
      });
  }
  
  onMount(fetchForm);
</script>
<style>
  pre, code {
    white-space: pre-wrap;
    text-align: justify;
  }
</style>
{@html markdown}
